import React from 'react';
import MarginSpace from '../../MarginSpace/MarginSpace';
import Panel from '../../MarginSpace/Panel/Panel';
import styles from './PageRow.module.scss';
import { CreateProps } from '../../../types/utils/CreateProps';

type PageRowProps = CreateProps<
  {
    /** If the padding should be removed in the sm and smaller screen size */
    responsiveFullWidth?: boolean;
    /** Define if children is Panel, so paddings are set if panel is omitted */
    hasPanel?: boolean;
  },
  typeof MarginSpace
>;

const PageRow: React.FunctionComponent<PageRowProps> = ({
  children,
  className,
  margin = { bottom: 'lg' },
  responsiveFullWidth,
  narrow,
  hasPanel = responsiveFullWidth && narrow,
  ...props
}) => (
  <MarginSpace
    className={[styles.pageRow, className]}
    margin={margin}
    noPaddingForSmallerThanSm={responsiveFullWidth}
    narrow={narrow}
    {...props}
  >
    {narrow && !hasPanel ? (
      <Panel transparent>
        <Panel.Content>{children}</Panel.Content>
      </Panel>
    ) : (
      children
    )}
  </MarginSpace>
);

export default PageRow;
